import { render, staticRenderFns } from "./StickyNotes.vue?vue&type=template&id=3b18090f&scoped=true"
import script from "./StickyNotes.vue?vue&type=script&lang=ts"
export * from "./StickyNotes.vue?vue&type=script&lang=ts"
import style0 from "./StickyNotes.vue?vue&type=style&index=0&id=3b18090f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18090f",
  null
  
)

export default component.exports